export { StateManager } from "@cogo/runtime-v2"
